export type PerfStats = { fps: number; p50: number; p95: number }

export const telemetry = {
  log: (event: string, data?: unknown) => {
    if (import.meta.env.DEV) {
      // No persistence; console only in dev
      // eslint-disable-next-line no-console
      console.log(`[telemetry] ${event}`, data ?? '')
    }
  }
}
